export const protocoloParse = (value) => {
  if (value) {
    return {
      value: value.replace(/(\d{2})(\d{6})(\d{4})/, '$1/$2/$3')
    }
  } else {
    return ''
  }
}

export const protocoloSpiParse = (value) => {
  if (value) {
    return {
      value: value.replace(/(\d{2})(\d{4})(\d{6})/, '$1/$3/$2')
    }
  } else {
    return ''
  }
}

export const protocoloSpiParseWithoutSlash = (value) => {
  if (value) {
    return {
      value: value.replace(/(\d{2})(\d{4})(\d{6})/, '$1$3$2')
    }
  } else {
    return ''
  }
}

export const telefoneParse = (telefone) => {
  if (telefone) {
    return {
      value: telefone.replace(/(\d{4})(\d{4})/, '$1-$2')
    }
  } else {
    return ''
  }
}

export const tipoContatoExterno = (value) => {
  var dictionary = {
    PESSOAFISICA: 'Pessoa Fisica',
    PESSOAJURIDICA: 'Pessoa Juridica',
    PODERPUBLICO: 'Poder Publico',
    SERVIDOR: 'Servidor',
    PODEREXECUTIVO: 'Poder Executivo Estadual',
    INSCRICAOESTADUAL: 'Inscrição Estadual',
    DEFAULT: ''
  }

  if (!dictionary[value]) {
    return {
      value
    }
  }

  return {
    value: dictionary[value]
  }
}

export const toContantoExterno = (value) => {
  var dictionary = {
    'Pessoa Fisica': 'PESSOAFISICA',
    'Pessoa Juridica': 'PESSOAJURIDICA',
    'Poder Publico': 'PODERPUBLICO',
    'Poder Executivo Estadual': 'PODEREXECUTIVO',
    Servidor: 'SERVIDOR',
    DEFAULT: ''
  }

  if (!dictionary[value]) {
    return {
      value
    }
  }

  return {
    value: dictionary[value]
  }
}
